import { render, staticRenderFns } from "./SelectedStudent.vue?vue&type=template&id=7d9cca36&scoped=true"
import script from "./SelectedStudent.vue?vue&type=script&lang=js"
export * from "./SelectedStudent.vue?vue&type=script&lang=js"
import style0 from "./SelectedStudent.vue?vue&type=style&index=0&id=7d9cca36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9cca36",
  null
  
)

export default component.exports